/* PROJ-67 Besties — Layout-Vertrag. GETEILT: byte-identisch in
 * distantlines/assets/ und blanket_frontend/. Nur Werte, die BEIDE Seiten
 * brauchen. Theme-only-UI (Preset-Beschriftungen etc.) gehoert in
 * besties-presets.js und NICHT hierher. Alle Masse in Druck-Pixeln. */
(function (w) {
  'use strict';
  w.BESTIES_LAYOUT = {
    id: 'besties',
    canvas: { w: 2100, h: 2400 },

    themes: {
      black: { ink: '#F2F0EB', titleAssets: 'besties-title-light-' },
      white: { ink: '#1F1D1A', titleAssets: 'besties-title-dark-' }
    },

    // Vertikales Budget, in allen Varianten gleich:
    //   Titelband   120 .. 400
    //   Fotoflaeche 460 .. 1900
    //   Namen       1980
    //   Spruch      2110
    //   Rand unten  bis 2400
    variants: {
      // Ein-Foto-Variante (Ansage Dominik 09.08.): ein grosses Bild ueber die
      // volle Fotoflaeche, Titel/Namen/Icons/Spruch identisch zur '3'.
      '1': {
        photos: [
          { x: 130, y: 570, w: 1840, h: 1430 }
        ],
        title: { x: 130, y: 95, w: 1840, lineH: 200, lines: 3, align: 'center', stroke: 6,
                 lineHeight: 0.88, maxOverlap: 0.2, fillRatio: 1,
                 maxTracking: 0.2,
                 maxStretch: 1.7 },
        names: { x: 130, y: 2060, w: 1840, size: 62, align: 'left', font: 'futura-pt',
                 case: 'upper', maxChars: 30, autoshrink: true, fillChar: '/' },
        icons: { x: 130, y: 2170, w: 700, h: 143 },
        quote: { x: 1000, y: 2170, w: 970, size: 62, align: 'right', maxLines: 2 }
      },
      '3': {
        photos: [
          { x: 130, y: 570, w: 900, h: 1430 },
          { x: 1070, y: 570, w: 900, h: 700 },
          { x: 1070, y: 1300, w: 900, h: 700 }
        ],
        title: { x: 130, y: 95, w: 1840, lineH: 200, lines: 3, align: 'center', stroke: 6,
                 // fillRatio: Zielbreite als Anteil der Rahmenbreite. Kurze
                 // Titel erreichen sie ueber Sperrung, nicht ueber mehr
                 // Schriftgroesse -- die ist durch maxOverlap gedeckelt.
                 // maxTracking begrenzt die Sperrung auf ein Vielfaches der
                 // Schriftgroesse. Reicht die Breite damit nicht, wird die
                 // SCHRIFT groesser und maxOverlap gibt nach -- ein
                 // auseinandergerissenes Wort ist schlimmer als tiefere
                 // Ueberlappung.
                 lineHeight: 0.88, maxOverlap: 0.2, fillRatio: 1,
                 maxTracking: 0.2,
                 // maxStretch: waagerechtes Ziehen als letzte Reserve.
                 // Macht senkrechte Striche dicker, im DTG unkritisch.
                 maxStretch: 1.7 },
        names: { x: 130, y: 2060, w: 1840, size: 62, align: 'left', font: 'futura-pt',
                 case: 'upper', maxChars: 30, autoshrink: true, fillChar: '/' },
        icons: { x: 130, y: 2170, w: 700, h: 143 },
        quote: { x: 1000, y: 2170, w: 970, size: 62, align: 'right', maxLines: 2 }
      },
      '5': {
        photos: [
          { x: 130, y: 570, w: 900, h: 700 },
          { x: 130, y: 1300, w: 900, h: 700 },
          { x: 1070, y: 570, w: 900, h: 456 },
          { x: 1070, y: 1056, w: 900, h: 456 },
          { x: 1070, y: 1542, w: 900, h: 458 }
        ],
        title: { x: 130, y: 95, w: 1840, lineH: 200, lines: 3, align: 'center', stroke: 6,
                 // fillRatio: Zielbreite als Anteil der Rahmenbreite. Kurze
                 // Titel erreichen sie ueber Sperrung, nicht ueber mehr
                 // Schriftgroesse -- die ist durch maxOverlap gedeckelt.
                 // maxTracking begrenzt die Sperrung auf ein Vielfaches der
                 // Schriftgroesse. Reicht die Breite damit nicht, wird die
                 // SCHRIFT groesser und maxOverlap gibt nach -- ein
                 // auseinandergerissenes Wort ist schlimmer als tiefere
                 // Ueberlappung.
                 lineHeight: 0.88, maxOverlap: 0.2, fillRatio: 1,
                 maxTracking: 0.2,
                 // maxStretch: waagerechtes Ziehen als letzte Reserve.
                 // Macht senkrechte Striche dicker, im DTG unkritisch.
                 maxStretch: 1.7 },
        names: { x: 130, y: 2060, w: 1840, size: 62, align: 'left', font: 'futura-pt',
                 case: 'upper', maxChars: 30, autoshrink: true, fillChar: '/' },
        icons: { x: 130, y: 2170, w: 700, h: 143 },
        quote: { x: 1000, y: 2170, w: 970, size: 62, align: 'right', maxLines: 2 }
      },
      '8': {
        photos: [
          { x: 130, y: 570, w: 586, h: 700 },
          { x: 130, y: 1300, w: 586, h: 700 },
          { x: 756, y: 570, w: 586, h: 456 },
          { x: 756, y: 1056, w: 586, h: 456 },
          { x: 756, y: 1542, w: 586, h: 458 },
          { x: 1382, y: 570, w: 588, h: 456 },
          { x: 1382, y: 1056, w: 588, h: 456 },
          { x: 1382, y: 1542, w: 588, h: 458 }
        ],
        title: { x: 130, y: 95, w: 1840, lineH: 200, lines: 3, align: 'center', stroke: 6,
                 // fillRatio: Zielbreite als Anteil der Rahmenbreite. Kurze
                 // Titel erreichen sie ueber Sperrung, nicht ueber mehr
                 // Schriftgroesse -- die ist durch maxOverlap gedeckelt.
                 // maxTracking begrenzt die Sperrung auf ein Vielfaches der
                 // Schriftgroesse. Reicht die Breite damit nicht, wird die
                 // SCHRIFT groesser und maxOverlap gibt nach -- ein
                 // auseinandergerissenes Wort ist schlimmer als tiefere
                 // Ueberlappung.
                 lineHeight: 0.88, maxOverlap: 0.2, fillRatio: 1,
                 maxTracking: 0.2,
                 // maxStretch: waagerechtes Ziehen als letzte Reserve.
                 // Macht senkrechte Striche dicker, im DTG unkritisch.
                 maxStretch: 1.7 },
        names: { x: 130, y: 2060, w: 1840, size: 62, align: 'left', font: 'futura-pt',
                 case: 'upper', maxChars: 30, autoshrink: true, fillChar: '/' },
        icons: { x: 130, y: 2170, w: 700, h: 143 },
        quote: { x: 1000, y: 2170, w: 970, size: 62, align: 'right', maxLines: 2 }
      }
    },

    // filter ist eine fertige CSS-Filterkette, die die Engine unveraendert
    // durchreicht. Der Wert ist Dominiks "Black & White"-Preset, wortgleich
    // aus photo.css:1172 -- dasselbe, was Fotoposter, Definitionsposter,
    // Film-, Song- und Magazinposter benutzen. Hier aenderbar, ohne Code
    // anzufassen: die 5 Prozent Kontrast sind auf Papier sichtbar, im
    // DTG-Druck auf Textil moeglicherweise zu wenig.
    photoStyle: { filter: 'grayscale(1) contrast(1.05)', fit: 'cover', radius: 0 },
    // Zweite Schrift fuer die Namenszeile. Futura PT kommt aus Dominiks
    // Adobe-Fonts-Kit, das Theme und Renderer ohnehin laden.
    // Handeinstellung einzelner Titel, schlaegt die Automatik feldweise.
    // Die Titelliste ist geschlossen, also darf hier von Hand gestellt
    // werden. Leer lassen heisst: Automatik entscheidet.
    // Beispiel: 'BESTIES': { size: 197, tracking: 39, stretch: 1.7 }
    titleTuning: {},

    fonts: [{ family: 'Clash Display', weight: 700 },
            { family: 'futura-pt', weight: 700 }]
  };
})(window);
